import qs from 'qs'
import Crafts from '../../components/crafts/Crafts'
import { get } from '../../components/helpers/Api'

const CraftsPage = (props) => {
    return <Crafts {...props} />
}

CraftsPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    const values = qs.parse(paths[paths.length - 1].replace('crafts?', ''))

    values['search_page'] = false
    values['searchType'] = values['search_type']
        ? values['search_type']
        : 'crafts'

    if (values['collection'] && values['collection'] !== '*')
        values['collection_details'] = await get(
            'collection-minimal/' + values['collection'],
            'legacy',
        )

    return values
}

export default CraftsPage
